/*
 * Copyright (c) University of Technology Sydney. All rights reserved.
 * See LICENSE file in the project root for full license information.
 *
 * Project Name: wpt-frontend.
 * Author: Tim Porritt
 * Created: 27/10/21
 */

import UTSIcons from './uts';
import StreamlineIcons from './streamline';
import MaterialIcons from './material';

export default {
    ...UTSIcons,
    ...StreamlineIcons,
    ...MaterialIcons,
};
